<template>
  <div class="w-full md:mt-10">
    <div class="footer-top container">
      <div class="list-icons container-small">
        <a v-if="urls.make_contact" :href="urls.make_contact ?? '#'" target="_blank" class="icon-item">
          <chat class="w-6 icon h-6" />
          <span class="text-black mt-auto">{{ textSnippets.make_contact }}</span>
        </a>
        <a v-if="urls.on_site_consultation" :href="urls.on_site_consultation ?? '#'" class="icon-item">
          <place class="w-6 icon h-6" />
          <span class="text-black mt-auto">{{ textSnippets.on_site_consultation }}</span>
        </a>
        <div class="icon-item cursor-pointer md:!hidden" @click="$emit('restartQuiz')">
          <reload class="w-6 icon h-6" />
          <span class="text-black mt-auto">{{ textSnippets.repeat_skin_advice }}</span>
        </div>
      </div>
    </div>
    <div class="footer-body mt-40">
      <div class="text-base font-semibold mb-6 text-center">
        <span>{{ textSnippets.dr_hauschka_quotes_1 }} {{ textSnippets.dr_hauschka_quotes_2 }}</span>
      </div>
      <div class="flex items-center justify-center mb-8 space-x-4">
        <a v-if="urls.facebook" :href="urls.facebook ?? '#'" target="_blank"
          ><ph-facebook-logo weight="bold" color="#fff" :size="70" class="icon-social facebook p-3.5"
        /></a>
        <a v-if="urls.instagram" :href="urls.instagram ?? '#'" target="_blank"
          ><ph-instagram-logo weight="bold" color="#fff" :size="70" class="icon-social instagram p-3.5"
        /></a>
        <a v-if="urls.vk" :href="urls.vk ?? '#'" target="_blank"><vk class="icon-social vk p-3.5 w-18 h-18" /></a>
      </div>
      <div class="grid grid-flow-col place-content-center gap-4">
        <a v-if="urls.imprint" :href="urls.imprint ?? '#'" class="footer-link">{{ textSnippets.imprint }}</a>
        <a v-if="urls.data_protection" :href="urls.data_protection ?? '#'" class="footer-link">{{
          textSnippets.data_protection
        }}</a>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useMainStore } from '@/store/main'
import { computed } from 'vue'
import vk from '@/assets/img/vk-logo.svg'
import { PhInstagramLogo, PhFacebookLogo } from '@dnlsndr/vue-phosphor-icons'
import chat from '@/assets/icons/chat.svg'
import place from '@/assets/icons/place.svg'
import reload from '@/assets/icons/reload.svg'
/**
 * register Store
 */
const store = useMainStore()

/**
 * @return {Language} textSnippets
 */
const textSnippets = computed(() => store.snippets)

/**
 * @return {Urls} urls
 */
const urls = computed(() => store.urls)
</script>
<style scoped>
.footer-top {
  @apply flex flex-col;
}

.list-icons {
  @apply grid gap-20 grid-cols-2 md:grid-cols-none md:grid-flow-col place-content-start w-full;
}

.icon-item {
  @apply flex flex-col transition duration-300 ease-in-out gap-4;
}

.icon {
  @apply cursor-pointer;
}

.footer-body {
  @apply pt-6 px-8 pb-7 md:p-16 bg-light-grey flex items-center justify-center flex-col;
}

.icon-social {
  @apply cursor-pointer rounded-xl bg-dark-grey hover:bg-black hover:text-white transition duration-500 ease-in-out;
}

.footer-link {
  @apply block text-base mb-4 md:mr-9 md:last:mr-0 md:mb-0 font-semibold;
}
</style>
